import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AppInitializerService {
  constructor(private translate: TranslateService) {}

  initialize(): Observable<any> {
    console.log('Initializing app translations...');

    this.translate.setDefaultLang('en');
    this.translate.addLangs(['en', 'ar', 'de']);

    const savedLanguage = localStorage.getItem('selected-language') || 'en';
    console.log(`Loading translations for language: ${savedLanguage}`);

    return this.translate
      .use(savedLanguage)
      .pipe(
        catchError((error) => {
          console.error('Failed to load initial translations:', error);
          return of(null);
        })
      )
      .pipe(
        map(() => {
          const direction = savedLanguage === 'ar' ? 'rtl' : 'ltr';
          document.documentElement.dir = direction;
          document.documentElement.lang = savedLanguage;
          return null;
        })
      );
  }
}

export function initializeApp(appInitializer: AppInitializerService) {
  return () => appInitializer.initialize();
}
